'use strict';

module.exports = require('./Autosuggest').default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/node_modules/react-autosuggest/dist/index.js
// module id = 5111
// module chunks = 25